import { useEffect, useState } from 'react';
import { useGlobalStoreSelector } from './stores/global.store';

// The platform favicon, used before any Brand resolves and for unbranded workspaces. Not a
// tenant asset: no shell site hardcodes a foreign CloudFront logo anymore.
const PLATFORM_FAVICON = '/vadio_192.svg';

export const Favicon = () => {
	const [linkElement, setLinkElement] = useState<HTMLLinkElement | null>(null);

	// A route-tree override (the customer portal) wins over the resolved-brand slot: a branded
	// workspace paints its own favicon, everything else paints the platform mark.
	const faviconUrl = useGlobalStoreSelector(
		(state) =>
			state.faviconOverride ??
			(state.resolvedBrand?.isBranded ? (state.resolvedBrand.faviconUrl ?? PLATFORM_FAVICON) : PLATFORM_FAVICON),
	);

	useEffect(() => {
		const link = document.createElement('link');
		link.rel = 'icon';
		document.head.appendChild(link);
		setLinkElement(link);
	}, []);

	useEffect(() => {
		if (linkElement) {
			linkElement.href = faviconUrl;
		}
	}, [faviconUrl, linkElement]);

	return null;
};
